



















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Dialog } from 'vant';
import * as config from '../config';
Vue.use(Dialog);
@Component({
  components: {},
})
export default class ListItem extends Vue {
  option = config.OPTHINES;
  @Prop() item!: any;
  @Prop({ default: true }) showVotes!: any;

  name = '';
  school = '';
  class = '';

  enterDetail(item: any) {
    if (item.enable === '-1') {
      Dialog({ message: '未审核通过，请上传符合要求的作品' });
    } else {
      this.$router.push({
        path: './Detail',
        query: { id: item.id, source: this.$route.query.source },
      });
    }
  }
}
